import React from 'react'
import { Space, Tag } from 'antd'
import styles from './StageTag.module.css'
import { WarningTwoTone } from '@ant-design/icons'
import { useFeatureFlags } from 'hooks/useFeatureFlags'

export const StageTag = () => {
  const { isStage } = useFeatureFlags()

  if (!isStage) return null

  return (
    <div className={styles.tagContainer}>
      <Tag color="#fff4e5" className={styles.tag}>
        <Space>
          <WarningTwoTone twoToneColor="orange" />
          <span className={styles.tagText}>Stage environment</span>
        </Space>
      </Tag>
    </div>
  )
}
